import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  Category,
  CategoryPreview,
  CategoryResource,
  CreateCategoryRequestParams,
} from 'src/models/category.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class CategoryService {
  private readonly http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  createCategory = (body: CreateCategoryRequestParams) =>
    this.http.post<CategoryResource[]>(`${this.apiUrl}topics`, body);

  getCategories = () => this.http.get<CategoryPreview[]>(`${this.apiUrl}topics`);

  updateCategories = (categoryArray: CategoryResource[]) =>
    // Null must be added for the BE to pick up on it being deleted
    this.http.post<CategoryResource>(`${this.apiUrl}topics/bulk-update`, {
      categoryArray: categoryArray.map(cat => ({
        ...cat,
        ...(!cat.topicParentID && { topicParentID: null }),
      })),
    });

  deleteCategory = (categoryID: number) =>
    this.http.delete<unknown>(`${this.apiUrl}topics/${categoryID}`);

  searchCategories = (categories: Category[], searchTerm: string, expand = true): Category[] => {
    const lowerCaseSearchTerm: string = searchTerm.toLowerCase();
    const filteredCategories: Category[] = categories.filter(cat => {
      const normalizedTitle: string = cat.topicTitle.toLowerCase();
      return normalizedTitle.includes(lowerCaseSearchTerm);
    });

    if (searchTerm.length === 0) {
      return filteredCategories;
    }

    const outputTree: Category[] = [];

    filteredCategories.forEach((category: Category) => {
      let parent = categories.find(cat => cat.id === category.topicParentID);

      const exists = outputTree.find(cat => cat.id === category.id);
      while (parent) {
        const parentExists = outputTree.find(cat => cat.id === parent?.id);
        if (!parentExists) {
          outputTree.push(parent);
        }
        if (expand) {
          parent.isExpanded = true;
        }
        parent = categories.find(cat => cat.id === parent?.topicParentID);
      }
      if (!exists) {
        outputTree.push(category);
      }
    });

    return outputTree;
  };
}
